import { createFileRoute } from '@tanstack/react-router'
import ImportRetailOders from 'Imports/components/RetailerOrders/ImportRetailOders'

import { Guard } from '../-guard'

export const Route = createFileRoute('/imports/createretailerorders')({
    component: () => (
        <Guard claims={['opus_integration']}>
            <ImportRetailOders />
        </Guard>
    ),
})
